// This file is auto-generated by @hey-api/openapi-ts

import type { ApplyTypicalDayResponse, ApplyTypicalDayWithActivityResponse, CreateAvailabilityResponse, CreateCallResponse, CreateCommentResponse, CreateDiplomaResponse, CreateEventChildResponse, CreateEventEnrollmentResponse, CreateEventResponse, CreateEventWithActivityResponse, CreateMyEnrollmentResponse, CreateTeamDailyTaskResponse, CreateTemplateResponse, GetInvitationResponse, GetOpinionThreadResponse, GetTrainerProfileResponse, ListAdminParticipantsResponse, ListAvailabilitiesResponse, ListCallsResponse, ListCommentsResponse, ListEventChildrenResponse, ListEventEnrollmentsResponse, ListEventsResponse, ListEventsWithActivityResponse, ListForTeamResponse, ListGestionnaireMeetingsMyScopeResponse, ListGestionnaireMeetingsOngoingResponse, ListGestionnaireMeetingsResponse, ListInChargeEventsResponse, ListInChargeEventsWithActivityResponse, ListMeetingEnrollmentsResponse, ListMeetingsResponse, ListModularEventsResponse, ListMyAvailabilitiesResponse, ListMyDailyEventsResponse, ListMyDailyEventsWithActivityResponse, ListMyEnrollmentsResponse, ListOwnPlanningEventsResponse, ListOwnPlanningEventsWithActivityResponse, ListParticipantOpinionsResponse, ListParticipantsResponse, ListPlanningEventsResponse, ListPlanningEventsWithActivityResponse, ListPublicEventsResponse, ListPublicEventsWithActivityResponse, ListPublicMeetingsResponse, ListPublicModularEventsResponse, ListSupervisorEventsResponse, ListSupervisorEventsWithActivityResponse, ListTeamDailyTasksResponse, ListTemplateContentsResponse, ListTemplatesResponse, ListTypicalDayEventsResponse, ListTypicalDayEventsWithActivityResponse, ListUserDiplomasResponse, PatchAdminParticipantResponse, PatchAvailabilityResponse, PatchCommentResponse, PatchDiplomaResponse, PatchEventResponse, PatchEventWithActivityResponse, PatchGestionnaireInvitationResponse, PatchGestionnaireMeetingResponse, PatchMyParticipationResponse, PatchParticipantOpinionResponse, PatchParticipantResponse, PatchTeamDailyTaskResponse, PatchTemplateResponse, PatchTrainerProfileResponse, PostOpinionThreadMessageResponse, ReopenOpinionThreadResponse, ResolveOpinionThreadResponse, RetrieveAdminParticipantResponse, RetrieveCommentResponse, RetrieveEventResponse, RetrieveEventWithActivityResponse, RetrieveForTeamResponse, RetrieveGestionnaireInvitationResponse, RetrieveGestionnaireMeetingResponse, RetrieveMeetingResponse, RetrieveMeResponse, RetrieveMyEnrollmentResponse, RetrieveMyParticipationResponse, RetrieveParticipantOpinionResponse, RetrieveParticipantResponse, RetrievePublicMeetingResponse, RetrieveTeamDailyTaskResponse, RetrieveTemplateResponse, ScheduleTemplateResponse, UpdateCallResponse, UpdateCommentResponse, UpdateEventResponse, UpdateEventWithActivityResponse, UpdateParticipantOpinionResponse, UpdateParticipantResponse, UpdateTeamDailyTaskResponse, UpdateTemplateResponse, UpdateTrainerProfileResponse } from './types.gen';

const meetingOutSchemaResponseTransformer = (data: any) => {
    if (data.intranet_last_sync) {
        data.intranet_last_sync = new Date(data.intranet_last_sync);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.tagada_participants_last_sync) {
        data.tagada_participants_last_sync = new Date(data.tagada_participants_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    return data;
};

const pagedMeetingOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => meetingOutSchemaResponseTransformer(item));
    return data;
};

export const listMeetingsResponseTransformer = async (data: any): Promise<ListMeetingsResponse> => {
    data = pagedMeetingOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveMeetingResponseTransformer = async (data: any): Promise<RetrieveMeetingResponse> => {
    data = meetingOutSchemaResponseTransformer(data);
    return data;
};

const ownParticipationOutSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    return data;
};

export const retrieveMyParticipationResponseTransformer = async (data: any): Promise<RetrieveMyParticipationResponse> => {
    data = ownParticipationOutSchemaResponseTransformer(data);
    return data;
};

export const patchMyParticipationResponseTransformer = async (data: any): Promise<PatchMyParticipationResponse> => {
    data = ownParticipationOutSchemaResponseTransformer(data);
    return data;
};

const meetingPublicOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

const pagedMeetingPublicOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => meetingPublicOutSchemaResponseTransformer(item));
    return data;
};

export const listPublicMeetingsResponseTransformer = async (data: any): Promise<ListPublicMeetingsResponse> => {
    data = pagedMeetingPublicOutSchemaResponseTransformer(data);
    return data;
};

export const retrievePublicMeetingResponseTransformer = async (data: any): Promise<RetrievePublicMeetingResponse> => {
    data = meetingPublicOutSchemaResponseTransformer(data);
    return data;
};

export const listGestionnaireMeetingsResponseTransformer = async (data: any): Promise<ListGestionnaireMeetingsResponse> => {
    data = pagedMeetingOutSchemaResponseTransformer(data);
    return data;
};

export const listGestionnaireMeetingsMyScopeResponseTransformer = async (data: any): Promise<ListGestionnaireMeetingsMyScopeResponse> => {
    data = pagedMeetingOutSchemaResponseTransformer(data);
    return data;
};

const ongoingMeetingOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

export const listGestionnaireMeetingsOngoingResponseTransformer = async (data: any): Promise<ListGestionnaireMeetingsOngoingResponse> => {
    data = data.map((item: any) => ongoingMeetingOutSchemaResponseTransformer(item));
    return data;
};

export const retrieveGestionnaireMeetingResponseTransformer = async (data: any): Promise<RetrieveGestionnaireMeetingResponse> => {
    data = meetingOutSchemaResponseTransformer(data);
    return data;
};

export const patchGestionnaireMeetingResponseTransformer = async (data: any): Promise<PatchGestionnaireMeetingResponse> => {
    data = meetingOutSchemaResponseTransformer(data);
    return data;
};

const invitationConfigOutSchemaResponseTransformer = (data: any) => {
    if (data.deadline) {
        data.deadline = new Date(data.deadline);
    }
    return data;
};

export const retrieveGestionnaireInvitationResponseTransformer = async (data: any): Promise<RetrieveGestionnaireInvitationResponse> => {
    data = invitationConfigOutSchemaResponseTransformer(data);
    return data;
};

export const patchGestionnaireInvitationResponseTransformer = async (data: any): Promise<PatchGestionnaireInvitationResponse> => {
    data = invitationConfigOutSchemaResponseTransformer(data);
    return data;
};

const diplomaStubOutSchemaResponseTransformer = (data: any) => {
    data.issue_date = new Date(data.issue_date);
    return data;
};

const participantUserOutSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.diplomas) {
        data.diplomas = data.diplomas.map((item: any) => diplomaStubOutSchemaResponseTransformer(item));
    }
    return data;
};

const meetingParticipantListOutSchemaResponseTransformer = (data: any) => {
    if (data.user) {
        data.user = participantUserOutSchemaResponseTransformer(data.user);
    }
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.intranet_last_sync) {
        data.intranet_last_sync = new Date(data.intranet_last_sync);
    }
    if (data.user_last_sync) {
        data.user_last_sync = new Date(data.user_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    return data;
};

const pagedMeetingParticipantListOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => meetingParticipantListOutSchemaResponseTransformer(item));
    return data;
};

export const listAdminParticipantsResponseTransformer = async (data: any): Promise<ListAdminParticipantsResponse> => {
    data = pagedMeetingParticipantListOutSchemaResponseTransformer(data);
    return data;
};

const meetingParticipantOutSchemaResponseTransformer = (data: any) => {
    if (data.user) {
        data.user = participantUserOutSchemaResponseTransformer(data.user);
    }
    if (data.rg_user) {
        data.rg_user = participantUserOutSchemaResponseTransformer(data.rg_user);
    }
    if (data.dt_user) {
        data.dt_user = participantUserOutSchemaResponseTransformer(data.dt_user);
    }
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.intranet_last_sync) {
        data.intranet_last_sync = new Date(data.intranet_last_sync);
    }
    if (data.user_last_sync) {
        data.user_last_sync = new Date(data.user_last_sync);
    }
    if (data.tagada_avis_last_sync) {
        data.tagada_avis_last_sync = new Date(data.tagada_avis_last_sync);
    }
    data.created = new Date(data.created);
    data.updated = new Date(data.updated);
    return data;
};

export const retrieveAdminParticipantResponseTransformer = async (data: any): Promise<RetrieveAdminParticipantResponse> => {
    data = meetingParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const patchAdminParticipantResponseTransformer = async (data: any): Promise<PatchAdminParticipantResponse> => {
    data = meetingParticipantOutSchemaResponseTransformer(data);
    return data;
};

const invitationMeetingOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

const invitationPublicOutSchemaResponseTransformer = (data: any) => {
    data.meeting = invitationMeetingOutSchemaResponseTransformer(data.meeting);
    if (data.deadline) {
        data.deadline = new Date(data.deadline);
    }
    return data;
};

export const getInvitationResponseTransformer = async (data: any): Promise<GetInvitationResponse> => {
    data = invitationPublicOutSchemaResponseTransformer(data);
    return data;
};

const meOutSchemaResponseTransformer = (data: any) => {
    if (data.birthdate) {
        data.birthdate = new Date(data.birthdate);
    }
    if (data.last_sync) {
        data.last_sync = new Date(data.last_sync);
    }
    data.participations = data.participations.map((item: any) => ownParticipationOutSchemaResponseTransformer(item));
    data.diplomas = data.diplomas.map((item: any) => diplomaStubOutSchemaResponseTransformer(item));
    return data;
};

export const retrieveMeResponseTransformer = async (data: any): Promise<RetrieveMeResponse> => {
    data = meOutSchemaResponseTransformer(data);
    return data;
};

const infoTemplateOutSchemaResponseTransformer = (data: any) => {
    if (data.scheduled_at) {
        data.scheduled_at = new Date(data.scheduled_at);
    }
    if (data.sent_at) {
        data.sent_at = new Date(data.sent_at);
    }
    return data;
};

export const listTemplatesResponseTransformer = async (data: any): Promise<ListTemplatesResponse> => {
    data = data.map((item: any) => infoTemplateOutSchemaResponseTransformer(item));
    return data;
};

export const createTemplateResponseTransformer = async (data: any): Promise<CreateTemplateResponse> => {
    data = infoTemplateOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveTemplateResponseTransformer = async (data: any): Promise<RetrieveTemplateResponse> => {
    data = infoTemplateOutSchemaResponseTransformer(data);
    return data;
};

export const patchTemplateResponseTransformer = async (data: any): Promise<PatchTemplateResponse> => {
    data = infoTemplateOutSchemaResponseTransformer(data);
    return data;
};

export const updateTemplateResponseTransformer = async (data: any): Promise<UpdateTemplateResponse> => {
    data = infoTemplateOutSchemaResponseTransformer(data);
    return data;
};

const infoContentOutSchemaResponseTransformer = (data: any) => {
    if (data.opened_at) {
        data.opened_at = new Date(data.opened_at);
    }
    data.created = new Date(data.created);
    return data;
};

export const listTemplateContentsResponseTransformer = async (data: any): Promise<ListTemplateContentsResponse> => {
    data = data.map((item: any) => infoContentOutSchemaResponseTransformer(item));
    return data;
};

export const scheduleTemplateResponseTransformer = async (data: any): Promise<ScheduleTemplateResponse> => {
    data = infoTemplateOutSchemaResponseTransformer(data);
    return data;
};

export const listParticipantsResponseTransformer = async (data: any): Promise<ListParticipantsResponse> => {
    data = pagedMeetingParticipantListOutSchemaResponseTransformer(data);
    return data;
};

const opinionCommentOutSchemaResponseTransformer = (data: any) => {
    if (data.date) {
        data.date = new Date(data.date);
    }
    return data;
};

const opinionParticipantOutSchemaResponseTransformer = (data: any) => {
    if (data.js_opinion) {
        data.js_opinion = opinionCommentOutSchemaResponseTransformer(data.js_opinion);
    }
    if (data.sgdf_opinion) {
        data.sgdf_opinion = opinionCommentOutSchemaResponseTransformer(data.sgdf_opinion);
    }
    return data;
};

const pagedOpinionParticipantOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => opinionParticipantOutSchemaResponseTransformer(item));
    return data;
};

export const listParticipantOpinionsResponseTransformer = async (data: any): Promise<ListParticipantOpinionsResponse> => {
    data = pagedOpinionParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveParticipantResponseTransformer = async (data: any): Promise<RetrieveParticipantResponse> => {
    data = meetingParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const patchParticipantResponseTransformer = async (data: any): Promise<PatchParticipantResponse> => {
    data = meetingParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const updateParticipantResponseTransformer = async (data: any): Promise<UpdateParticipantResponse> => {
    data = meetingParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveParticipantOpinionResponseTransformer = async (data: any): Promise<RetrieveParticipantOpinionResponse> => {
    data = opinionParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const patchParticipantOpinionResponseTransformer = async (data: any): Promise<PatchParticipantOpinionResponse> => {
    data = opinionParticipantOutSchemaResponseTransformer(data);
    return data;
};

export const updateParticipantOpinionResponseTransformer = async (data: any): Promise<UpdateParticipantOpinionResponse> => {
    data = opinionParticipantOutSchemaResponseTransformer(data);
    return data;
};

const meetingCommentOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    if (data.date) {
        data.date = new Date(data.date);
    }
    return data;
};

const pagedMeetingCommentOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => meetingCommentOutSchemaResponseTransformer(item));
    return data;
};

export const listCommentsResponseTransformer = async (data: any): Promise<ListCommentsResponse> => {
    data = pagedMeetingCommentOutSchemaResponseTransformer(data);
    return data;
};

export const createCommentResponseTransformer = async (data: any): Promise<CreateCommentResponse> => {
    data = meetingCommentOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveCommentResponseTransformer = async (data: any): Promise<RetrieveCommentResponse> => {
    data = meetingCommentOutSchemaResponseTransformer(data);
    return data;
};

export const patchCommentResponseTransformer = async (data: any): Promise<PatchCommentResponse> => {
    data = meetingCommentOutSchemaResponseTransformer(data);
    return data;
};

export const updateCommentResponseTransformer = async (data: any): Promise<UpdateCommentResponse> => {
    data = meetingCommentOutSchemaResponseTransformer(data);
    return data;
};

const opinionReviewMessageOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    return data;
};

const opinionReviewThreadOutSchemaResponseTransformer = (data: any) => {
    if (data.resolved_at) {
        data.resolved_at = new Date(data.resolved_at);
    }
    data.messages = data.messages.map((item: any) => opinionReviewMessageOutSchemaResponseTransformer(item));
    return data;
};

export const getOpinionThreadResponseTransformer = async (data: any): Promise<GetOpinionThreadResponse> => {
    data = opinionReviewThreadOutSchemaResponseTransformer(data);
    return data;
};

export const postOpinionThreadMessageResponseTransformer = async (data: any): Promise<PostOpinionThreadMessageResponse> => {
    data = opinionReviewThreadOutSchemaResponseTransformer(data);
    return data;
};

export const resolveOpinionThreadResponseTransformer = async (data: any): Promise<ResolveOpinionThreadResponse> => {
    data = opinionReviewThreadOutSchemaResponseTransformer(data);
    return data;
};

export const reopenOpinionThreadResponseTransformer = async (data: any): Promise<ReopenOpinionThreadResponse> => {
    data = opinionReviewThreadOutSchemaResponseTransformer(data);
    return data;
};

const eventPublicOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

const pagedEventPublicOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => eventPublicOutSchemaResponseTransformer(item));
    return data;
};

export const listPublicEventsResponseTransformer = async (data: any): Promise<ListPublicEventsResponse> => {
    data = pagedEventPublicOutSchemaResponseTransformer(data);
    return data;
};

const eventOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

const pagedEventOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => eventOutSchemaResponseTransformer(item));
    return data;
};

export const listPlanningEventsResponseTransformer = async (data: any): Promise<ListPlanningEventsResponse> => {
    data = pagedEventOutSchemaResponseTransformer(data);
    return data;
};

export const listOwnPlanningEventsResponseTransformer = async (data: any): Promise<ListOwnPlanningEventsResponse> => {
    data = pagedEventOutSchemaResponseTransformer(data);
    return data;
};

export const listMyDailyEventsResponseTransformer = async (data: any): Promise<ListMyDailyEventsResponse> => {
    data = pagedEventPublicOutSchemaResponseTransformer(data);
    return data;
};

export const listSupervisorEventsResponseTransformer = async (data: any): Promise<ListSupervisorEventsResponse> => {
    data = pagedEventPublicOutSchemaResponseTransformer(data);
    return data;
};

export const listInChargeEventsResponseTransformer = async (data: any): Promise<ListInChargeEventsResponse> => {
    data = pagedEventPublicOutSchemaResponseTransformer(data);
    return data;
};

export const listTypicalDayEventsResponseTransformer = async (data: any): Promise<ListTypicalDayEventsResponse> => {
    data = pagedEventOutSchemaResponseTransformer(data);
    return data;
};

const modularChildOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

const modularEventOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    data.modular_children = data.modular_children.map((item: any) => modularChildOutSchemaResponseTransformer(item));
    return data;
};

const pagedModularEventOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => modularEventOutSchemaResponseTransformer(item));
    return data;
};

export const listModularEventsResponseTransformer = async (data: any): Promise<ListModularEventsResponse> => {
    data = pagedModularEventOutSchemaResponseTransformer(data);
    return data;
};

const publicEventOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    return data;
};

const publicModularEventOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    data.modular_children = data.modular_children.map((item: any) => publicEventOutSchemaResponseTransformer(item));
    return data;
};

const pagedPublicModularEventOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => publicModularEventOutSchemaResponseTransformer(item));
    return data;
};

export const listPublicModularEventsResponseTransformer = async (data: any): Promise<ListPublicModularEventsResponse> => {
    data = pagedPublicModularEventOutSchemaResponseTransformer(data);
    return data;
};

export const listEventsResponseTransformer = async (data: any): Promise<ListEventsResponse> => {
    data = pagedEventOutSchemaResponseTransformer(data);
    return data;
};

export const createEventResponseTransformer = async (data: any): Promise<CreateEventResponse> => {
    data = eventOutSchemaResponseTransformer(data);
    return data;
};

export const applyTypicalDayResponseTransformer = async (data: any): Promise<ApplyTypicalDayResponse> => {
    data = data.map((item: any) => eventOutSchemaResponseTransformer(item));
    return data;
};

const enrollmentOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const pagedEnrollmentOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => enrollmentOutSchemaResponseTransformer(item));
    return data;
};

export const listMyEnrollmentsResponseTransformer = async (data: any): Promise<ListMyEnrollmentsResponse> => {
    data = pagedEnrollmentOutSchemaResponseTransformer(data);
    return data;
};

export const listMeetingEnrollmentsResponseTransformer = async (data: any): Promise<ListMeetingEnrollmentsResponse> => {
    data = data.map((item: any) => enrollmentOutSchemaResponseTransformer(item));
    return data;
};

export const retrieveEventResponseTransformer = async (data: any): Promise<RetrieveEventResponse> => {
    data = eventOutSchemaResponseTransformer(data);
    return data;
};

export const patchEventResponseTransformer = async (data: any): Promise<PatchEventResponse> => {
    data = eventOutSchemaResponseTransformer(data);
    return data;
};

export const updateEventResponseTransformer = async (data: any): Promise<UpdateEventResponse> => {
    data = eventOutSchemaResponseTransformer(data);
    return data;
};

const eventWithActivityOutSchemaResponseTransformer = (data: any) => {
    data.start_date = new Date(data.start_date);
    data.end_date = new Date(data.end_date);
    if (data.enrollment_publication_publication_date) {
        data.enrollment_publication_publication_date = new Date(data.enrollment_publication_publication_date);
    }
    if (data.enrollment_publication_opening_date) {
        data.enrollment_publication_opening_date = new Date(data.enrollment_publication_opening_date);
    }
    if (data.enrollment_publication_closing_date) {
        data.enrollment_publication_closing_date = new Date(data.enrollment_publication_closing_date);
    }
    return data;
};

export const listEventChildrenResponseTransformer = async (data: any): Promise<ListEventChildrenResponse> => {
    data = data.map((item: any) => eventWithActivityOutSchemaResponseTransformer(item));
    return data;
};

export const createEventChildResponseTransformer = async (data: any): Promise<CreateEventChildResponse> => {
    data = eventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveMyEnrollmentResponseTransformer = async (data: any): Promise<RetrieveMyEnrollmentResponse> => {
    if (data) {
        data = enrollmentOutSchemaResponseTransformer(data);
    }
    return data;
};

export const createMyEnrollmentResponseTransformer = async (data: any): Promise<CreateMyEnrollmentResponse> => {
    data = enrollmentOutSchemaResponseTransformer(data);
    return data;
};

export const listEventEnrollmentsResponseTransformer = async (data: any): Promise<ListEventEnrollmentsResponse> => {
    data = data.map((item: any) => enrollmentOutSchemaResponseTransformer(item));
    return data;
};

export const createEventEnrollmentResponseTransformer = async (data: any): Promise<CreateEventEnrollmentResponse> => {
    data = enrollmentOutSchemaResponseTransformer(data);
    return data;
};

const pagedPublicEventOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => publicEventOutSchemaResponseTransformer(item));
    return data;
};

export const listPublicEventsWithActivityResponseTransformer = async (data: any): Promise<ListPublicEventsWithActivityResponse> => {
    data = pagedPublicEventOutSchemaResponseTransformer(data);
    return data;
};

const pagedEventWithActivityOutSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => eventWithActivityOutSchemaResponseTransformer(item));
    return data;
};

export const listPlanningEventsWithActivityResponseTransformer = async (data: any): Promise<ListPlanningEventsWithActivityResponse> => {
    data = pagedEventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const listOwnPlanningEventsWithActivityResponseTransformer = async (data: any): Promise<ListOwnPlanningEventsWithActivityResponse> => {
    data = pagedPublicEventOutSchemaResponseTransformer(data);
    return data;
};

export const listMyDailyEventsWithActivityResponseTransformer = async (data: any): Promise<ListMyDailyEventsWithActivityResponse> => {
    data = pagedPublicEventOutSchemaResponseTransformer(data);
    return data;
};

export const listSupervisorEventsWithActivityResponseTransformer = async (data: any): Promise<ListSupervisorEventsWithActivityResponse> => {
    data = pagedPublicEventOutSchemaResponseTransformer(data);
    return data;
};

export const listInChargeEventsWithActivityResponseTransformer = async (data: any): Promise<ListInChargeEventsWithActivityResponse> => {
    data = pagedPublicEventOutSchemaResponseTransformer(data);
    return data;
};

export const listTypicalDayEventsWithActivityResponseTransformer = async (data: any): Promise<ListTypicalDayEventsWithActivityResponse> => {
    data = pagedEventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const listEventsWithActivityResponseTransformer = async (data: any): Promise<ListEventsWithActivityResponse> => {
    data = pagedEventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const createEventWithActivityResponseTransformer = async (data: any): Promise<CreateEventWithActivityResponse> => {
    data = eventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const applyTypicalDayWithActivityResponseTransformer = async (data: any): Promise<ApplyTypicalDayWithActivityResponse> => {
    data = data.map((item: any) => eventOutSchemaResponseTransformer(item));
    return data;
};

export const retrieveEventWithActivityResponseTransformer = async (data: any): Promise<RetrieveEventWithActivityResponse> => {
    data = eventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const patchEventWithActivityResponseTransformer = async (data: any): Promise<PatchEventWithActivityResponse> => {
    data = eventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

export const updateEventWithActivityResponseTransformer = async (data: any): Promise<UpdateEventWithActivityResponse> => {
    data = eventWithActivityOutSchemaResponseTransformer(data);
    return data;
};

const teamDailyTaskOutSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

export const listTeamDailyTasksResponseTransformer = async (data: any): Promise<ListTeamDailyTasksResponse> => {
    data = data.map((item: any) => teamDailyTaskOutSchemaResponseTransformer(item));
    return data;
};

export const createTeamDailyTaskResponseTransformer = async (data: any): Promise<CreateTeamDailyTaskResponse> => {
    data = teamDailyTaskOutSchemaResponseTransformer(data);
    return data;
};

export const retrieveTeamDailyTaskResponseTransformer = async (data: any): Promise<RetrieveTeamDailyTaskResponse> => {
    data = teamDailyTaskOutSchemaResponseTransformer(data);
    return data;
};

export const patchTeamDailyTaskResponseTransformer = async (data: any): Promise<PatchTeamDailyTaskResponse> => {
    data = teamDailyTaskOutSchemaResponseTransformer(data);
    return data;
};

export const updateTeamDailyTaskResponseTransformer = async (data: any): Promise<UpdateTeamDailyTaskResponse> => {
    data = teamDailyTaskOutSchemaResponseTransformer(data);
    return data;
};

export const listForTeamResponseTransformer = async (data: any): Promise<ListForTeamResponse> => {
    data = data.map((item: any) => teamDailyTaskOutSchemaResponseTransformer(item));
    return data;
};

export const retrieveForTeamResponseTransformer = async (data: any): Promise<RetrieveForTeamResponse> => {
    data = teamDailyTaskOutSchemaResponseTransformer(data);
    return data;
};

const trainerAvailabilityOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const listAvailabilitiesResponseTransformer = async (data: any): Promise<ListAvailabilitiesResponse> => {
    data = data.map((item: any) => trainerAvailabilityOutSchemaResponseTransformer(item));
    return data;
};

export const createAvailabilityResponseTransformer = async (data: any): Promise<CreateAvailabilityResponse> => {
    data = trainerAvailabilityOutSchemaResponseTransformer(data);
    return data;
};

export const patchAvailabilityResponseTransformer = async (data: any): Promise<PatchAvailabilityResponse> => {
    data = trainerAvailabilityOutSchemaResponseTransformer(data);
    return data;
};

const trainerAvailabilityNotNestedOutSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const listMyAvailabilitiesResponseTransformer = async (data: any): Promise<ListMyAvailabilitiesResponse> => {
    data = data.map((item: any) => trainerAvailabilityNotNestedOutSchemaResponseTransformer(item));
    return data;
};

const trainerCallOutSchemaResponseTransformer = (data: any) => {
    data.called_at = new Date(data.called_at);
    if (data.responded_at) {
        data.responded_at = new Date(data.responded_at);
    }
    return data;
};

export const listCallsResponseTransformer = async (data: any): Promise<ListCallsResponse> => {
    data = data.map((item: any) => trainerCallOutSchemaResponseTransformer(item));
    return data;
};

export const createCallResponseTransformer = async (data: any): Promise<CreateCallResponse> => {
    data = trainerCallOutSchemaResponseTransformer(data);
    return data;
};

export const updateCallResponseTransformer = async (data: any): Promise<UpdateCallResponse> => {
    data = trainerCallOutSchemaResponseTransformer(data);
    return data;
};

const diplomaOutSchemaResponseTransformer = (data: any) => {
    if (data.issue_date) {
        data.issue_date = new Date(data.issue_date);
    }
    if (data.expiry_date) {
        data.expiry_date = new Date(data.expiry_date);
    }
    return data;
};

const pastMeetingOutSchemaResponseTransformer = (data: any) => {
    if (data.start_date) {
        data.start_date = new Date(data.start_date);
    }
    if (data.end_date) {
        data.end_date = new Date(data.end_date);
    }
    return data;
};

const trainerProfileOutSchemaResponseTransformer = (data: any) => {
    data.diplomas = data.diplomas.map((item: any) => diplomaOutSchemaResponseTransformer(item));
    if (data.bafd_issue_date) {
        data.bafd_issue_date = new Date(data.bafd_issue_date);
    }
    if (data.bafd_expiry_date) {
        data.bafd_expiry_date = new Date(data.bafd_expiry_date);
    }
    data.past_meetings = data.past_meetings.map((item: any) => pastMeetingOutSchemaResponseTransformer(item));
    if (data.availabilities_last_updated_at) {
        data.availabilities_last_updated_at = new Date(data.availabilities_last_updated_at);
    }
    return data;
};

export const getTrainerProfileResponseTransformer = async (data: any): Promise<GetTrainerProfileResponse> => {
    data = trainerProfileOutSchemaResponseTransformer(data);
    return data;
};

export const patchTrainerProfileResponseTransformer = async (data: any): Promise<PatchTrainerProfileResponse> => {
    data = trainerProfileOutSchemaResponseTransformer(data);
    return data;
};

export const updateTrainerProfileResponseTransformer = async (data: any): Promise<UpdateTrainerProfileResponse> => {
    data = trainerProfileOutSchemaResponseTransformer(data);
    return data;
};

export const listUserDiplomasResponseTransformer = async (data: any): Promise<ListUserDiplomasResponse> => {
    data = data.map((item: any) => diplomaStubOutSchemaResponseTransformer(item));
    return data;
};

export const createDiplomaResponseTransformer = async (data: any): Promise<CreateDiplomaResponse> => {
    data = diplomaStubOutSchemaResponseTransformer(data);
    return data;
};

export const patchDiplomaResponseTransformer = async (data: any): Promise<PatchDiplomaResponse> => {
    data = diplomaStubOutSchemaResponseTransformer(data);
    return data;
};
